module.exports = __webpack_public_path__ + "static/share_image-c4e9f284c189a6ee1310766d30d18bf0.png";